import React, { useState } from "react"
import { View, Text, TouchableOpacity, TextInput } from "react-native"
import { ThemeContext } from "../utility/context/ThemeContext"
import { textStyles } from "../style"

type Props = {
  inputRef?: React.MutableRefObject<TextInput>
  value: string
  onChangeText: (text: string) => void
  onSubmitEditing: () => void
  error?: string
}

const MFAInput = ({
  inputRef,
  value,
  onChangeText,
  onSubmitEditing,
  error,
}: Props): React.ReactElement<Props> => {
  const theme = React.useContext(ThemeContext).theme
  const { textMain, bgMain, primary } = theme.colors

  const inputValues = Array.from({ length: 6 }, (_, i) => value[i] || "")

  const [isFocused, setIsFocused] = useState(false)

  return (
    <View style={{flexDirection: "column", alignItems: "center"}}>
      <View
        style={{
          position: "relative",
          flexDirection: "row",
          gap: 10,
          justifyContent: "center",
          alignItems: "center",
          height: 50,
        }}
      >
        {
        inputValues.map((char, index) => (
          <TouchableOpacity
            key={index}
            style={{
              width: 40,
              height: 50,
              borderWidth: 1,
              borderColor: (
                (value.length == index || (value.length == 6 && index == 5 )) && isFocused
              ) ? primary : textMain,
              backgroundColor: bgMain,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 5,
            }}
            onPress={() => {
              inputRef?.current?.focus()
            }}
          >
            <Text style={{ color: textMain, fontSize: 20 }}>{char}</Text>
          </TouchableOpacity>
        ))
        }

        {/* Full-size (but visually hidden) input improves Android WebView stability */}
        <TextInput
          ref={inputRef}
          pointerEvents="none"
          style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            right: 0,
            opacity: 0,
          }}
          value={value}
          onChangeText={onChangeText}
          // iOS can still render a caret even when opacity is 0.
          // Hide the caret + selection highlight so only the OTP boxes are visible.
          caretHidden
          selectionColor="transparent"
          // Prefer iOS OTP autofill behavior.
          textContentType="oneTimeCode"
          onSubmitEditing={() => {
            if (value.length != 6) return

            onSubmitEditing()
          }}
          keyboardType="number-pad"
          autoComplete="one-time-code"
          autoCorrect={false}
          maxLength={6}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
      </View>
      {error && (
        <Text style={[textStyles.subscript, {color: theme.colors.danger, marginTop: 5}]}>
          {error}
        </Text>
      )}
    </View>
    
  )
}

export default MFAInput